import axios from 'axios'
axios.defaults.baseURL = process.env.REACT_APP_URL

axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  config.headers.post['Content-Type'] = 'application/json'
  config.headers.common.Accept = 'application/json'
  // config.headers.post['Access-Control-Allow-Origin'] = '*'
  // console.log(config)
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
axios.interceptors.response.use(function (config) {
  config.headers['cache-control'] = 'no-cache, no-store, must-revalidate'
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
const authenticationService = {

  loginUserApi: async (data) => {
    return await axios.post('/login', data)
  }
}

export default authenticationService
